import ApiDocsView from "./OpenPlatform/ApiDocsView";
import RealTimeView from "./RealTime/RealTimeView";
import DataMapView from "./DataMap/DataMapView";
import FormView from "./Form/FormView";
import QueryingWorksView from "./Querying/QueryingWorksView";
import PermView from "./Perm/PermView";
import UserProfileView from "./UserProfile/UserProfileView";
import QuickBIView from "./Form/QuickBIView";
import LoggerDemoView from "./Logger/LoggerDemoView";
import QueryingGuideView from "./QueryingGuide/QueryingGuideView";
import TemplateQueryingViewV2 from "./QueryingGuide/TemplateQueryingViewV2";
import QueryingExportingView from "./Querying/QueryingExportingView";
import VisualizationReleaseView from "./QueryingGuide/VisualizationReleaseView";
import IndexView from "./IndexView";
import auth from "./Service/AuthFetchService";
import { isEmpty } from "./Service/Utils";

import Script from "react-load-script";
import React from "react";
import { BrowserRouter as Router, Switch, Link, Route } from "react-router-dom";
//import { browserHistory } from 'react-router';
import {
  Row,
  Col,
  Layout,
  Menu,
  Avatar,
  Space,
  Modal,
  Input,
  message,
  Dropdown,
  notification,
  Descriptions
} from "antd";
import { QuestionCircleOutlined, EditOutlined, LogoutOutlined } from "@ant-design/icons";
import "./App.css";
import UIFetchService from "./Service/UIFetchService";

const { Header, Content } = Layout;
const logout = (e) => {
  document.cookie = "cya_internal_token=; expires=-1; path=/"
  window.location = "/";
};
const items = [
  {
    label: '退出登录',
    key: '1',
    icon: <LogoutOutlined />,
  },
];
const menuProps = {
  items,
  onClick: logout,
};

class App extends React.Component {
  constructor() {
    super();
    const path = window.location.pathname;
    let view = "IndexView";
    if (path.startsWith("/forms")) {
      view = "FormView";
    } else if (path.startsWith("/user_profile")) {
      view = "UserProfileView";
    } else if (path.startsWith("/real_time")) {
      view = "RealTimeView";
    } else if (path.startsWith("/querying_works")) {
      view = "QueryingWorksView";
    } else if (path.startsWith("/querying_guide")) {
      view = "QueryingGuideView";
    } else if (path.startsWith("/data_map")) {
      view = "DataMapView";
    } else if (path.startsWith("/open_platform")) {
      view = "OpenPlatformView";
    } else if (path.startsWith("/admin")) {
      view = "PermView";
    } else if (auth.prefix("datap:form:")) {
      view = "FormView";
    } else if (auth.prefix("datap:user_profile:")) {
      view = "UserProfileView";
    } else if (auth.allow("datap:querying:works")) {
      view = "QueryingWorksView";
    } else if (auth.allow("datap:querying:guild")) {
      view = "QueryingGuildView";
    } else if (auth.allow("datap:admin")) {
      view = "PermView";
    }

    this.state = {
      user: { account: "",avatar: ""},
      currentView: view,
      feedback: {
        visible: false,
        counterTop: 100,
      },
    };

    //设置登录cookie
    let urlStr = window.location.href.split("?")[1];
    const urlSearchParams = new URLSearchParams(urlStr);
    const result = Object.fromEntries(urlSearchParams.entries());
    if (!isEmpty(result["wx_token"])) {
      var date = new Date();
      date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie =
        "cya_internal_token=" +
        result["wx_token"] +
        "; expires=" +
        date.toGMTString() +
        "; path=/";
    }
  }

  async componentDidMount() {
    const json = await auth.authenticate();
    this.setState({ user: json });
    auth.appendLog("Index");

    //上线公告
    if (new Date() < new Date('2024-11-09') && localStorage.getItem('is_update_notify_showed_20241107') === null) {
      notification.info({
        message: '平台更新公告',
        description: (<> 1.SQL查询数据开发增加脚本搜索功能<br/>
        2.天机数据订阅功能升级：<br/>
        <div style={{ marginLeft: '15px' }}>1)支持推送明细数据</div>
        <div style={{ marginLeft: '15px' }}>2️)支持推送数据到个人企业微信</div>
        </>),
        duration: 0,
      }) 

      localStorage.setItem('is_update_notify_showed_20241107',1)
    }
  }

  componentWillUnmount() {}

  onSelect = (item) => {
    this.setState({ currentView: item.key });
    auth.appendLog(item.key);
  };

  

  render() {
    return (
      <>
        <Router forceRefresh={true}>
          <Switch>
            <Route
              path="/standalone/group_daily_form"
              render={() => <QuickBIView fixedHeight pageName="集团日报" />}
            />
            <Route
              path="/standalone/group_weekly_form"
              render={() => <QuickBIView fixedHeight pageName="集团周报" />}
            />
            <Route
              path="/standalone/group_monthly_form"
              render={() => <QuickBIView fixedHeight pageName="集团月报" />}
            />
            <Route
              path="/standalone/referral_daily_form"
              render={() => <QuickBIView fixedHeight pageName="私域导流日报" />}
            />
            <Route
              path="/standalone/referral_daily_form_v2"
              render={() => <QuickBIView fixedHeight pageName="导流日报" />}
            />
            <Route
              path="/standalone/group_realtime"
              render={() => <QuickBIView fixedHeight pageName="实时大盘" />}
            />
            <Route
              path="/standalone/bcz_core_form"
              render={() => (
                <QuickBIView fixedHeight pageName="百词斩核心报表" />
              )}
            />
            <Route
              path="/standalone/mintpie_core_form"
              render={() => (
                <QuickBIView fixedHeight pageName="薄荷芝士派核心报表" />
              )}
            />
            <Route
              path="/standalone/future_core_form"
              render={() => (
                <QuickBIView fixedHeight pageName="未来技能核心报表" />
              )}
            />
            <Route
              path="/standalone/mintpie_referral_daily_form"
              render={() => <QuickBIView fixedHeight pageName="薄芝导流日报" />}
            />
            <Route
              path="/standalone/fc_overview"
              render={() => <QuickBIView fixedHeight pageName="大营收多SKU总览" />}
            />
            <Route
              path="/standalone/abroad_core"
              render={() => <QuickBIView fixedHeight pageName="出国核心报表" />}
            />
            <Route
              path="/standalone/hardware_word_machine"
              render={() => <QuickBIView fixedHeight pageName="单词机核心报表" />}
            />
            <Route
              path="/standalone/hardware_overall"
              render={() => <QuickBIView fixedHeight pageName="硬件总览看板" />}
            />
            <Route
              path="/standalone/newreading_core"
              render={() => <QuickBIView fixedHeight pageName="新阅读核心看板" />}
            />
            <Route
              path="/standalone/logger_demo"
              render={() => <LoggerDemoView />}
            />
            <Route
              path="/standalone/templates/:id"
              render={(history) => (
                <div style={{ padding: "20px" }}>
                  <TemplateQueryingViewV2
                    tmplId={history.match.params.id}
                    offset={55}
                  />
                </div>
              )}
            />
            <Route
              path="/standalone/visualizations/:id"
              render={(history) => (
                <div style={{ padding: "20px" }}>
                  <VisualizationReleaseView vid={history.match.params.id} />
                </div>
              )}
            />
            <Route
              path="/standalone/exported"
              render={() => <QueryingExportingView />}
            />
            <Route render={() => this.renderLayout()} />
          </Switch>
        </Router>
        <Script
          url="https://7n.bczcdn.com/cyalogger/cya-logger.2.0.0.min.js"
          onLoad={this.didLoggerInitialized.bind(this)}
        />
      </>
    );
  }

  // 3 17 3 1

  renderLayout() {
    return (
      <>
        <Layout>
          <Header
            className="header"
            style={{ color: "#348BE3", backgroundColor: "#FFFFFF", padding: 0 }}
          >
            <div className="logo" />
            <Row>
              <Col
                flex="200px"
                style={{
                  borderBottom: "1px solid",
                  borderColor: "#f0f0f0",
                  //boxShadow: '0 1px 2px 0 rgba(209,209,209,0.28)'
                }}
              >
                <Row style={{ margin: "0px 0px 0px 40px" }}>
                  <Col flex="30px">
                    <img src="/logo.png" width="30" height="30" alt=""></img>
                  </Col>
                  <Col flex="130px">
                    <p
                      style={{
                        color: "#3C3D3F",
                        fontSize: 15,
                        fontWeight: 700,
                        lineHeight: 0,
                        margin: "22px 12px",
                      }}
                    >
                      超有爱数据中台
                    </p>
                    <p
                      style={{
                        color: "#66686B",
                        fontSize: 12,
                        lineHeight: 0,
                        margin: "0px 12px",
                      }}
                    >
                      数智未来
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col flex="auto">
                <Menu
                  theme="light"
                  mode="horizontal"
                  defaultSelectedKeys={[this.state.currentView]}
                  selectedKeys={[this.state.currentView]}
                  onSelect={(item) => this.setState({ currentView: item.key })}
                >
                  <Menu.Item key="IndexView">
                    <Link to="/">首页</Link>
                  </Menu.Item>
                  {auth.prefix("datap:form:") && (
                    <Menu.Item key="FormView">
                      <Link to="/forms">数据看板</Link>
                    </Menu.Item>
                  )}
                  {auth.prefix("datap:user_profile:") && (
                    <Menu.Item key="UserProfileView">
                      <Link to="/user_profile">用户画像</Link>
                    </Menu.Item>
                  )}
                  {auth.prefix("datap:real_time:") && (
                    <Menu.Item key="RealTimeView">
                      <Link to="/real_time">埋点管理</Link>
                    </Menu.Item>
                  )}
                  {auth.prefix("datap:querying_guide:") && (
                    <Menu.Item key="QueryingGuideView">
                      <Link to="/querying_guide">天机</Link>
                    </Menu.Item>
                  )}
                  {auth.allow("datap:querying:works") && (
                    <Menu.Item key="QueryingWorksView">
                      <Link to="/querying_works">SQL查询</Link>
                    </Menu.Item>
                  )}
                  <Menu.Item key="DataMapView">
                    <Link to="/data_map">数据地图</Link>
                  </Menu.Item>
                  <Menu.Item key="OpenPlatformView">
                    <Link to="/open_platform">开放平台</Link>
                  </Menu.Item>
                  <Menu.Item key="AdPlatformView">
                    <a
                      href="https://cyaad.baicizhan.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      广告平台
                    </a>
                  </Menu.Item>
                  {auth.allow("datap:admin") && (
                    <Menu.Item key="PermView">
                      <Link to="/admin">管理工具</Link>
                    </Menu.Item>
                  )}
                </Menu>
              </Col>
              <Col
                flex="150px"
                style={{
                  textAlign: "center",
                  borderBottom: "1px solid",
                  borderColor: "#f0f0f0",
                }}
              >
                <Dropdown menu={menuProps}>
                  <div style={{marginRight:'10px'}}>
                    <Avatar
                    style={{
                      backgroundColor: "#f56a00",
                      verticalAlign: "middle",
                    }}
                    size="large"
                    src={this.state.user.avatar}
                  >
                  {this.state.user.avatar == "" && this.state.user.account}
                  </Avatar>
                  {this.state.user.avatar != "" && <span style={{color: '#3C3D3F', margin: '20px 10px 10px 10px'}}>{this.state.user.account}</span>}
                  </div>
                </Dropdown>
              </Col>
            </Row>
          </Header>
          <Content style={{ padding: "0 0px", backgroundColor: "#FFFFFF" }}>
            <Route path="/" exact component={IndexView} />
            {auth.prefix("datap:form:") && (
              <Route path="/forms" component={FormView} />
            )}
            {auth.prefix("datap:user_profile:") && (
              <Route path="/user_profile" component={UserProfileView} />
            )}
            {auth.prefix("datap:real_time:") && (
              <Route path="/real_time" component={RealTimeView} />
            )}
            {auth.allow("datap:querying:works") && (
              <Route path="/querying_works" component={QueryingWorksView} />
            )}
            {auth.prefix("datap:querying_guide:") && (
              <Route path="/querying_guide" component={QueryingGuideView} />
            )}
            <Route path="/data_map" component={DataMapView} />
            <Route path="/open_platform" component={ApiDocsView} />
            {auth.allow("datap:admin") && (
              <Route path="/admin" component={PermView} />
            )}
          </Content>
        </Layout>
      </>
    );
  }

  computeTextCountLeft() {
    const len = isEmpty(this.state.feedback.content)
      ? 0
      : this.state.feedback.content.length;
    if (len < 10) {
      return 420;
    }
    if (len < 100) {
      return 410;
    }
    return 400;
  }

  didLoggerInitialized() {
    window.CyaLogger.init({
      logstore: "logs-product",
      projectName: "datap",
      appName: "datap-web",
      autoTrack: true,
    });
  }

  async sendFeedback() {
    if (isEmpty(this.state.feedback.content)) {
      message.error("反馈内容不能为空！");
      return;
    }

    await UIFetchService.post("/api/v1/user/feedback", {
      location: window.location.href,
      content: this.state.feedback.content,
    });

    this.setState(({ feedback }) => {
      feedback.visible = false;
      feedback.content = "";
      return { feedback };
    });
    message.success("提交成功");
  }
}

export default App;
